module.exports = __webpack_public_path__ + "img/logo-chart.ca5e4f6.png";